import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Col, Row, Button } from "reactstrap";
import cross from "../../../../public/svg/x-symbol-svgrepo-com.svg";
import style from "./InvestBuyModal.scss";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import moment from "moment";

const defaultFields = {
  AssetCouponRate: 0,
  SettlementCurrency: "",
  DebitTotal: 0,
  Commission: 0,
  BuyTotal: 0,
  IVA: 0,
};

const getAssetClassName = (assetClass) => {
  switch (assetClass) {
    case "Bonds":
    case "BondsARG":
      return "Bonos";
    case "Caucion":
      return "Cauciones";
    case "Equity":
      return "Acciones";
    case "Future":
      return "Futuros";
    case "MutualFunds":
      return "Fondos Mutuos";
    case "Options":
      return "Opciones";
    default:
      return assetClass;
  }
};

export const InvestBuyModal = ({ modal, toggle, item, trade, io, order }) => {
  const [fields, setFields] = useState(defaultFields);
  const [ioTotal, setIoTotal] = useState(0);

  useEffect(() => {
    return () => {
      setFields(defaultFields);
    };
  }, []);

  useEffect(() => {
    if (item) {
      if (!fields.SettlementCurrency) {
        const defaultCurrency = item.AssetInformation.SettlementCurrencies.find(
          (settlementCurrenciesItem) => settlementCurrenciesItem.SettlementCurrencyIsDefault
        );
        setFields((prevFields) => ({
          ...prevFields,
          SettlementCurrency: defaultCurrency.SettlementCurrencyISO,
        }));
      }
      if (fields.AssetCouponRate === 0) {
        item.AssetInformation.Payments.map((paymentItem) => {
          const paymentItemAssetCouponDate = new Date(paymentItem.AssetCouponDate);
          if (new Date() < paymentItemAssetCouponDate) {
            setFields((prevFields) => ({
              ...prevFields,
              AssetCouponRate: +paymentItem.AssetCouponRate,
            }));
            return;
          }
        });
      }
    }
  }, [item]);

  useEffect(() => {
    if (order) {
      if (!fields.Commission) {
        let newCharges = 0;

        if (order.CurrentAccount.Precheck.Fees) {
          order.CurrentAccount.Precheck.Fees.map((feeitem) => {
            newCharges += +feeitem.feevalue;
          });
        }

        const newCommission = +order.CurrentAccount.Precheck.commission - newCharges;

        setFields((prevFields) => ({
          ...prevFields,
          Commission: newCommission,
        }));
      }
    }
  }, [order]);

  useEffect(() => {
    if (io && io.items) {
      let newIoTotal = 0;
      io.items.map((ioItem) => {
        newIoTotal += +ioItem.Quantity;
      });
      setIoTotal(newIoTotal);
    }
  }, [io]);

  if (!trade || !item) return null;

  // const getName = (assetInformation) => {
  //   let res = assetInformation.IssuerName + " " + assetInformation.AssetRiskTypeDesc;
  //   return res;
  // };

  return (
    <Modal size="lg" isOpen={modal} contentClassName={style.content}>
      <ModalBody className={style.body}>
        <Row>
          <Col className={style.wrapperCol} lg="12">
            <Row className={style.row}>
              <div className={style.container}>
                <div className={style.successTitle}>
                  <p>Inversión realizada con éxito</p>
                  <img className={style.cross} src={cross} alt="cross" onClick={toggle} />
                </div>
                <div className={style.containerFirstRow}>
                  <div className={style.subtitle}>{getAssetClassName(item.AssetClassForm)}</div>
                  <h4 className={style.name}>{item.AssetName}</h4>
                </div>
                <div className={style.containerSecondRow}>
                  <Row>
                    <Col className={style.col} xs={6} sx={6} md={6} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>total debitado</div>
                      <div className={style.total}>
                        <FormattedNumber
                          value={ioTotal}
                          minimumFractionDigits={item.AssetInformation.CurrencyISO == "USD" ? 2 : 0}
                          maximumFractionDigits={item.AssetInformation.CurrencyISO == "USD" ? 2 : 0}
                        />
                      </div>
                    </Col>
                    <Col className={style.col} xs={6} sx={6} md={6} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>estado de la transacción</div>
                      <div className={style.state}>en proceso</div>
                    </Col>
                    <Col className={style.col} xs={6} sx={6} md={6} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>fecha</div>
                      <div className={style.date}>{moment().format("DD/MM/YYYY")}</div>
                    </Col>
                    <Col className={style.col} xs={6} sx={6} md={6} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>número de la operación</div>
                      <div className={style.operationNumber}>{trade.TradeId}</div>
                    </Col>
                  </Row>
                </div>
                <div className={style.containerThirdRow}>
                  <Row>
                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>número de la operación</div>
                      <div className={style.total}>{trade.TradeId}</div>
                    </Col>
                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>tipo de inversión</div>
                      <div className={style.state}>
                        {item.AssetInformation.AssetOfferType === "Private" ? "Privado" : null}
                        {item.AssetInformation.AssetOfferType === "Public" ? "Público" : null}
                      </div>
                    </Col>
                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>operación</div>
                      <div className={style.date}>compra</div>
                    </Col>
                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>precio</div>
                      <div className={style.operationNumber}>
                        <FormattedNumber
                          value={trade.TradeAvgPrice}
                          minimumFractionDigits={4}
                          maximumFractionDigits={4}
                        />
                      </div>
                    </Col>

                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>cantidad</div>
                      <div className={style.total}>
                        <FormattedNumber
                          value={trade.TradeQuantity}
                          minimumFractionDigits={0}
                          maximumFractionDigits={0}
                        />
                      </div>
                    </Col>
                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>rendimiento</div>
                      <div className={style.state}>
                        <FormattedNumber
                          value={item.AssetPerformance}
                          minimumFractionDigits={2}
                          maximumFractionDigits={2}
                        />
                        %
                      </div>
                    </Col>
                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>tasa nominal</div>
                      <div className={style.date}>
                        <FormattedNumber
                          value={item.AssetInformation.AssetPaymentRateFixed}
                          minimumFractionDigits={2}
                          maximumFractionDigits={2}
                        />
                        %
                      </div>
                    </Col>
                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>vencimiento</div>
                      <div className={style.operationNumber}>
                        {moment(item.AssetInformation.AssetMaturityDate).format("DD/MM/YYYY")}
                      </div>
                    </Col>

                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>comisión corretaje</div>
                      <div className={style.total}>
                        {`${fields.SettlementCurrency} `}
                        <FormattedNumber
                          value={fields.Commission}
                          minimumFractionDigits={item.AssetInformation.CurrencyISO == "USD" ? 2 : 0}
                          maximumFractionDigits={item.AssetInformation.CurrencyISO == "USD" ? 2 : 0}
                        />
                      </div>
                    </Col>
                    <Col className={style.col} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className={style.subtitle}>ISIN</div>
                      <div className={style.state}>{item.AssetInformation.AssetTicker}</div>
                    </Col>
                    <Col className={style.col} xs={12} sm={8} md={6} lg={6} xl={6} xxl={6}>
                      <div className={style.subtitle}>cuenta débito</div>
                      <div
                        className={style.date}
                      >{`${trade.activeAccount.PersonBankAccountName} nº${trade.activeAccount.PersonBankAccountNumber}`}</div>
                    </Col>
                  </Row>
                </div>
                <div className={style.footer}>
                  <Button
                    className={style.printButton}
                    onClick={() => {
                      window.print();
                    }}
                  >
                    Imprimir
                  </Button>
                </div>
              </div>
            </Row>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};
